import { combineReducers, configureStore } from "@reduxjs/toolkit"
import { setupListeners } from '@reduxjs/toolkit/query'
import { sentryReduxEnhancer } from "@/lib/utils/sentry"

import { organizationsApi } from '@/api/organizations/organizations.api'
import { specialistsApi } from '@/api/specialists/specialists.api'
import { patientsApi } from '@/api/patients/patients.api'
import { usersApi } from '@/api/users/users.api'

import profile from './reducers/profile-reducer'
import specialists from './reducers/specialists-reducer'

export const store = configureStore({
  reducer: combineReducers({
    profile,
    specialists,
    [organizationsApi.reducerPath]: organizationsApi.reducer,
    [specialistsApi.reducerPath]: specialistsApi.reducer,
    [patientsApi.reducerPath]: patientsApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
  }),
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
    .concat(organizationsApi.middleware)
    .concat(specialistsApi.middleware)
    .concat(patientsApi.middleware)
    .concat(usersApi.middleware),
  enhancers: defaultEnhancers => defaultEnhancers.concat(sentryReduxEnhancer)
});

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
